export enum FILE_RESPONSE {
    VALIDATED = 'file processed successfully',
    VIRUS = 'file contains a virus',
    UNABLE_TO_LOAD = 'unable to load file',
    INVALID_TYPE = 'invalid file type selected',
    DATA_ISSUES = 'file has errored due to data issues',
    HEADER_RECORD = 'unable to update header record',
    DETAIL_ROW = 'unable to insert detail row'
}